import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, LineChart, Line,
  AreaChart, Area, PieChart, Pie, Cell, XAxis,
} from 'recharts';

// Tiny ILLUSTRATIVE chart thumbnail shown inside the Coach panel while an
// autonomous plan runs. It uses fixed SAMPLE data only — never live query
// results — so the Coach never surfaces real customer data. The chart "fills
// in" as the plan progresses (progress 0..1 reveals more of the sample).
const SAMPLE = [
  { name: 'A', value: 42 }, { name: 'B', value: 28 }, { name: 'C', value: 35 },
  { name: 'D', value: 18 }, { name: 'E', value: 24 },
];
const COLORS = ['#8b5cf6', '#22d3ee', '#34d399', '#f59e0b', '#f472b6'];

export default function CoachChartPreview({ chartType = 'bar', progress = 1 }) {
  const t = String(chartType || 'bar').toLowerCase();
  const n = Math.max(1, Math.ceil(SAMPLE.length * Math.max(0.2, Math.min(1, progress))));
  const data = t === 'pie' ? SAMPLE : SAMPLE.slice(0, n);

  let chart;
  if (t === 'pie') {
    chart = (
      <PieChart>
        <Pie data={data} dataKey="value" nameKey="name" innerRadius={16} outerRadius={40} paddingAngle={2}>
          {data.map((e, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
        </Pie>
      </PieChart>
    );
  } else if (t === 'line') {
    chart = (
      <LineChart data={data}>
        <XAxis dataKey="name" hide />
        <Line type="monotone" dataKey="value" stroke="#8b5cf6" strokeWidth={2} dot={false} isAnimationActive={false} />
      </LineChart>
    );
  } else if (t === 'area') {
    chart = (
      <AreaChart data={data}>
        <XAxis dataKey="name" hide />
        <Area type="monotone" dataKey="value" stroke="#8b5cf6" fill="#8b5cf6" fillOpacity={0.3} isAnimationActive={false} />
      </AreaChart>
    );
  } else {
    chart = (
      <BarChart data={data}>
        <XAxis dataKey="name" hide />
        <Bar dataKey="value" radius={[3, 3, 0, 0]} isAnimationActive={false}>
          {data.map((e, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
        </Bar>
      </BarChart>
    );
  }

  return (
    <div data-testid="coach-chart-preview" className="rounded-lg border border-border/50 bg-muted/20 p-2">
      <div className="text-[10px] text-muted-foreground mb-1 flex items-center justify-between">
        <span>Preview · {t} chart</span>
        <span className="opacity-70">illustrative</span>
      </div>
      <div style={{ height: 92 }}>
        <ResponsiveContainer width="100%" height="100%">{chart}</ResponsiveContainer>
      </div>
    </div>
  );
}
